// extracted by mini-css-extract-plugin
export var modalFooter = "_nq-0";